/*=========================================================================================
  File Name: moduleAuthState.js
  Description: Auth Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  isUserLoggedIn: () => {
    let isAuthenticated = false

    return localStorage.getItem('userInfo') && isAuthenticated
  },

  isClientLoggedIn: () => {

    return localStorage.getItem('clientInfo') ? true : false
  },

  otp: [],
}
